import React from 'react';
import styles from './CredentialingDashboard.module.css';
import { useGetBadgeMediaQuery } from '../../slices/credentialingApi';

const combineClasses = (...classes) => classes.filter(Boolean).join(' ');

const BadgeImage = ({ badgeId, badgeName, badgeType, isGhost = false }) => {
  const { data, isLoading, isError } = useGetBadgeMediaQuery(badgeId, { skip: !badgeId });

  const media = data?.data || data || {};
  const heroUrl = media.image_url || media.large_url || media.image || media.hero_url;
  const iconUrl = media.icon_url || media.iconUrl || media.icon;
  const fallbackEmoji = '🏅';

  const wrapperClassName = combineClasses(
    styles.badgeArtwork,
    isGhost ? styles.badgeArtworkGhost : ''
  );

  let content;
  if (heroUrl) {
    content = (
      <img
        src={heroUrl}
        alt={`${badgeName || 'Badge'} artwork`}
        className={styles.badgeArtworkImage}
      />
    );
  } else if (iconUrl) {
    content = (
      <img
        src={iconUrl}
        alt={`${badgeName || 'Badge'} icon`}
        className={styles.badgeArtworkImage}
      />
    );
  } else if (isLoading && !isError) {
    content = <span className={styles.badgeArtworkLoading} aria-hidden="true" />;
  } else {
    content = (
      <span
        role="img"
        aria-label={`${badgeName || badgeType || 'Badge'} icon placeholder`}
        className={styles.badgeArtworkEmoji}
      >
        {fallbackEmoji || '🏅'}
      </span>
    );
  }

  return <div className={wrapperClassName}>{content}</div>;
};

export default BadgeImage;
